import { render } from "./CommunicationNewMessageContainer.vue?vue&type=template&id=603b5367&scoped=true&ts=true"
import script from "./CommunicationNewMessageContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationNewMessageContainer.vue?vue&type=script&lang=ts"

import "./CommunicationNewMessageContainer.vue?vue&type=style&index=0&id=603b5367&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603b5367"]])

export default __exports__